module.exports = __webpack_public_path__ + "img/three_human.c2b6bfbf.jpg";